import styled from 'styled-components';
import D from '@assets/themes/dimensions';

export const Root = styled.div`
  height: calc(100% - ${D.MAIN_APP_BAR_HEIGHT}px);
  width: 64px;
  padding: ${D.MAIN_APP_BAR_HEIGHT}px 0px 0px 0px;
  box-shadow: -4px 4px 10px 0 rgba(0, 0, 0, 0.05);
  background-color: white;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const EmptyContainer = styled.div`
  margin: 15px 0px 0px 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #b0aeae;
`